export default {
  "mainVegetable": "povrce",
  "mainVegetable/01": "povrce/plavi-patlidzan",
  "mainVegetable/02": "povrce/spargla",
  "mainVegetable/03": "povrce/avokado",
  "mainVegetable/04": "povrce/cvekla",
  "mainVegetable/05": "povrce/brokoli",
  "mainVegetable/06": "povrce/sargarepa",
  "mainVegetable/07": "povrce/celer",
  "mainVegetable/08": "povrce/pecurke",
  "mainVegetable/09": "povrce/kupus",
  "mainVegetable/10": "povrce/prokelj",
  "mainVegetable/11": "povrce/kineski-kupus",
  "mainVegetable/12": "povrce/karfiol",
  "mainVegetable/13": "povrce/salata-od-kupusa",
  "mainVegetable/14": "povrce/krastavac",
  "mainVegetable/15": "povrce/tikvice",
  "mainVegetable/16": "povrce/endive",
  "mainVegetable/17": "povrce/spanac",
  "mainVegetable/18": "povrce/fava-pasulj",
  "mainVegetable/19": "povrce/flageolet-pasulj",
  "mainVegetable/20": "povrce/ravni-pasulj",
  "mainVegetable/21": "povrce/suvi-pasulj",
  "mainVegetable/22": "povrce/boranija",
  "mainVegetable/23": "povrce/sociva",
  "mainVegetable/24": "povrce/miks-iseckanog-povrca",
  "mainVegetable/25": "povrce/kukuruz",
  "mainVegetable/26": "povrce/miks-zelenih-salata",
  "mainVegetable/27": "povrce/repa",
  "mainVegetable/28": "povrce/crni-luk",
  "mainVegetable/29": "povrce/grasak-soja",
  "mainVegetable/30": "povrce/paprike",
  "mainVegetable/31": "povrce/krompiri-i-krompiri",
  "mainVegetable/32": "povrce/klice-soje",
  "mainVegetable/33": "povrce/rotkvice",
  "mainVegetable/34": "povrce/hrastov-list-zelena-salata",
  "mainVegetable/35": "povrce/frizi-salata",
  "mainVegetable/36": "povrce/ajsber-zelena-salata",
  "mainVegetable/37": "povrce/pijemonteze-salata",
  "mainVegetable/38": "povrce/pirinac-salata",
  "mainVegetable/39": "povrce/roman-zelena-salata",
  "mainVegetable/40": "povrce/mlade-biljke",
  "mainVegetable/41": "povrce/zelena-salata",
  "mainVegetable/42": "povrce/jagnjeca-salata",
  "mainVegetable/43": "povrce/rukola",
  "mainVegetable/44": "povrce/crni-koren",
  "mainVegetable/45": "povrce/tobule",
  "mainVegetable/46": "povrce/paradajz",
  "mainVegetable/47": "povrce/puter-pasulj",
  "mainVegetable/48": "povrce/leblebija",
  "mainVegetable/49": "povrce/praziluk",
  "mainVegetable/50": "povrce/bundeva",
  "mainVegetable/51": "povrce/bubrezasti-pasulj",
  "mainVegetable/52": "povrce/jabuke",
  "mainVegetable/53": "povrce/kestenje",
  "mainVegetable/54": "povrce/suve-sljive",
  "mainVegetable/55": "povrce/bastovan",
  "mainVegetable/56": "povrce/crne-masline",
  "mainVegetable/57": "povrce/articoke",
  "mainVegetable/58": "povrce/crvene-paprike",
  "mainVegetable/59": "povrce/pljosnata-boranija",
  "mainVegetable/60": "povrce/prolece",
  "mainVegetable/61": "povrce/ratatul",
  "mainVegetable/62": "povrce/kuskus",
  "mainVegetable/63": "povrce/tadzin",
  "mainVegetable/64": "povrce/kari-povrce",
  "mainVegetable/65": "povrce/case-graska",
  "mainVegetable/66": "povrce",
  "mainVegetable/67": "povrce/koralna-sociva",
  "mainVegetable/68": "povrce/kinoa",
  "mainVegetable/69": "povrce/spelta",
  "mainVegetable/70": "povrce/bulgur",
  "mainVegetable/71": "povrce/crveni-kupus",
  "mainVegetable/72": "povrce/kelj",
  "mainVegetable/73": "povrce/francuski-persun",
  "mainVegetable/74": "povrce/zrna-i-semena",
  "mainVegetable/75": "povrce/mahunarke",
  "mainVegetable/76": "povrce/slatki-krompir",
  "mainVegetable/77": "povrce/bundeve",
  "mainVegetable/78": "povrce/testo",
  "mainVegetable/79": "povrce/pasulj",
  "mainVegetable/80": "povrce/grasak-sargarepe",
  "mainVegetable/81": "povrce/grasak",
  "mainVegetable/82": "povrce/zelena-soja",
  "mainVegetable/83": "povrce/jecam",
  "mainVegetable/84": "povrce/miks-salate",
  "mainVegetable/85": "povrce/secer-vekna-cikorija-salata",
  "mainVegetable/86": "povrce/jagnjeca-salata",
  "mainVegetable/87": "povrce/bejbi-spanac",
  "mainVegetable/88": "povrce/bejbi-zelena-bativa-salata",
  "mainVegetable/89": "povrce/blitva",
  "mainVegetable/90": "povrce/pastrnjak",
  "mainVegetable/91": "povrce/crni-pirinac",
  "mainVegetable/92": "povrce/miks-pasulja",
  "mainVegetable/93": "povrce/crni-pasulj",
  "mainVegetable/94": "povrce/zasiljeni-kupus",
  "mainVegetable/95": "povrce/beli-pasulj",
  "mainVegetable/96": "povrce/suseni-paradajz",
  "mainVegetable/97": "povrce/miks-povrca",
  "mainVegetable/98": "povrce/butternut-tikva",
  "productRange": "rasponi",
  "productRange/4G_BIO": "rasponi",
  "productRange/4G_SRP": "rasponi",
  "productRange/CAN_A_POEL": "rasponi",
  "productRange/CAN_SEC_BI": "rasponi",
  "productRange/CAN_SEC_CO": "rasponi",
  "productRange/CAN_SEC_CU": "rasponi",
  "productRange/CAN_SEC_NA": "rasponi",
  "productRange/CAN_VAPEUR": "rasponi",
  "productRange/CAN_VEG_SA": "rasponi",
  "productRange/CAN_VEG_SR": "rasponi",
  "productRange/CLASSICVEG": "rasponi",
  "productRange/COLDVEGE": "rasponi",
  "productRange/COOKMUSH": "rasponi",
  "productRange/CRUDITES": "rasponi",
  "productRange/DE_NOS_PRO": "rasponi",
  "productRange/DOYMUSHACC": "rasponi",
  "productRange/DOYMUSHAPE": "rasponi",
  "productRange/DRYVEGE": "rasponi",
  "productRange/FROZENVEGE": "rasponi",
  "productRange/FRZ_ASTUCE": "rasponi",
  "productRange/FRZ_GRATIN": "rasponi",
  "productRange/FRZ_KELLO": "rasponi",
  "productRange/FRZ_LEG_CO": "rasponi",
  "productRange/FRZ_PUREES": "rasponi",
  "productRange/FRZ_VEG_BI": "rasponi",
  "productRange/FRZ_VEG_SR": "rasponi",
  "productRange/INDFROZVEG": "rasponi",
  "productRange/JEUNES_POU": "rasponi",
  "productRange/LAITUES": "rasponi",
  "productRange/LOOP": "rasponi",
  "productRange/LUNCH_BOWL": "rasponi",
  "productRange/MACHE_BASE": "rasponi",
  "productRange/MEL_LAITUE": "rasponi",
  "productRange/MUSHNATEMI": "rasponi",
  "productRange/MUSHNATENT": "rasponi",
  "productRange/MUSHNATEPA": "rasponi",
  "productRange/MUSHNATMIN": "rasponi",
  "productRange/MUSHROOMS": "rasponi",
  "productRange/SUNVEGE": "rasponi",
  "productRange/TRAIT_CRUD": "rasponi",
  "productRange/TRAIT_TABO": "rasponi",
  "productRange/TUS_RECETA": "rasponi",
  "productRange/WORLDVEGE": "rasponi",
  "productRange/PREPARED_VEG": "rasponi",
  "productRange/BEAN_SAUCE": "rasponi/pasulj-u-sosu",
  "productRange/BEANS": "rasponi/pasulj",
  "productRange/BIO": "rasponi/bio",
  "productRange/BOND_KIDS": "rasponi/bonduelle-deca",
  "productRange/CAN_BIO": "rasponi/bio-povrce",
  "productRange/CAN_SEC_PR": "rasponi/spremno-pripremljeno-povrce",
  "productRange/CARTA_DELL": "rasponi/salata-meni",
  "productRange/CAN_PETITS": "rasponi",
  "productRange/CAN_BOCAL": "rasponi",
  "productRange/CEREAL_CAN": "rasponi/ambijentalne-zitarice",
  "productRange/CEREAL_FRZ": "rasponi/zamrznute-zitarice",
  "productRange/CEREALI": "rasponi/zitarice",
  "productRange/CEREALLEGR": "rasponi/cereallegre-salata",
  "productRange/COCCOLE": "rasponi/coccole-salata",
  "productRange/CORN": "rasponi/kukuruz",
  "productRange/CREATIF": "rasponi/kreativno",
  "productRange/FRANCAIS": "rasponi/100-francusko",
  "productRange/FRZ_FRY_MI": "rasponi/zamrznute-mesavine-povrca-za-tiganj",
  "productRange/FRZ_MELANG": "rasponi/mesavine-povrca",
  "productRange/FRZ_POELEE": "rasponi",
  "productRange/INSALATE_D": "rasponi/farmerska-salata",
  "productRange/INSALATONA": "rasponi/salata-plus",
  "productRange/LE_REGIONA": "rasponi/regionalno",
  "productRange/LEGUMIO": "rasponi/mahunarke",
  "productRange/MIXES_CORN": "rasponi/miks-sa-kukuruzom",
  "productRange/MONO_VEGE": "rasponi/mono-povrce",
  "productRange/MUSHROOMS  ": "rasponi/pecurke",
  "productRange/NATURA_IN": "rasponi/priroda-u-serpi",
  "productRange/OTHER_VEG": "rasponi/ostalo-povrce",
  "productRange/PEAS": "rasponi/grasak",
  "productRange/READY_FROZ": "rasponi/gotova-zamrznuta-jela",
  "productRange/SOUPS": "rasponi/povrce-za-supu",
  "productRange/SPINACH": "rasponi/spanac",
  "productRange/STEAM_CAN": "rasponi/para-konzerva",
  "productRange/STEAM_FRZ": "rasponi/para-zamrznuto",
  "productRange/STEAM_MIX": "rasponi/zamrznuto-povrce-kuvano-na-pari",
  "productRange/STUZZICHIA": "rasponi/tizer",
  "productRange/TOUCHE": "rasponi/pojacivac-ukusa",
  "productRange/TRAIT_SAL": "rasponi/za-vasu-salatu",
  "productRange/TUS_RECETA ": "rasponi/vasi-recepti",
  "productRange/VEG_TO_FRY": "rasponi/povrce-za-przenje",
  "productRange/VEGGIE": "rasponi/povrce-pirinac",
  "productRange/FRZ_JUSTEA": "rasponi",
  "productRange/SALABIS": "rasponi",
  "productRange/BON_SENGAG": "rasponi",
  "productRange/CROUSTIS": "rasponi",
  "season": "sezone",
  "season/1": "sezone/leto",
  "season/2": "sezone/jesen",
  "season/3": "sezone/zima",
  "season/4": "sezone/prolece",
  "season/5": "sezone",
  "technologie": "tehnologija",
  "technologie/AC01": "tehnologija/konzerevans",
  "technologie/AD01": "tehnologija/zamrznuto",
  "technologie/AG01": "tehnologija/sveze",
  "technologie/AT01": "tehnologija/ketering",
  "recipeDish": "vrsta-jela",
  "recipeDish/ACC": "vrsta-jela/prilog",
  "recipeDish/APE": "vrsta-jela/aperitiv",
  "recipeDish/DES": "vrsta-jela/dezert",
  "recipeDish/ENT": "vrsta-jela/predjelo",
  "recipeDish/PLAT": "vrsta-jela/jelo",
  "recipeDish/SAL": "vrsta-jela/salata",
  "recipeDish/SNA": "vrsta-jela/snek-bar",
  "recipeDish/PDE": "vrsta-jela/dorucak",
  "recipeDish/DEJ": "vrsta-jela/rucak",
  "recipeDish/TRA": "vrsta-jela/tradicionalan",
  "recipeDish/GOU": "vrsta-jela/hrana-za-gurmane",
  "recipeDish/ETH": "vrsta-jela/etnicko",
  "recipeDish/FCH": "vrsta-jela/za-decu",
  "recipeDish/SOU": "vrsta-jela/supu",
  "pred-recipeTimingCook-facet": "pecenje",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "pecenje/0-15-minuta",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "pecenje/15-30-minuta",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "pecenje/30-45-minuta",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "pecenje/45-minuta",
  "pred-recipeTimingPreparation-facet": "priprema",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "priprema/0-15-minuta",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "priprema/15-30-minuta",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "priprema/30-45-minuta",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "priprema/45-minuta",
  "pred-recipeCost-Facet": "budzet",
  "pred-recipeCost-Facet/petit": "budzet/jeftino",
  "pred-recipeCost-Facet/moyen": "budzet/prosecno",
  "pred-recipeCost-Facet/grand": "budzet/skupo",
  "recipeDifficulty": "priprema",
  "recipeDifficulty/1": "priprema/lako",
  "recipeDifficulty/2": "priprema/srednje",
  "recipeDifficulty/3": "priprema/tesko",
  "recipeDishNumber": "gosti",
  "recipeDishNumber/1": "gosti/1",
  "recipeDishNumber/2": "gosti/2",
  "recipeDishNumber/3": "gosti/3",
  "recipeDishNumber/4": "gosti/4",
  "recipeDishNumber/5": "gosti/5",
  "recipeDishNumber/6": "gosti/6",
  "recipeDishNumber/7": "gosti/7",
  "recipeDishNumber/8": "gosti/8",
  "productTheme": "proizvodi-po-temama",
  "productTheme/ACC": "proizvodi-po-temama/prilog",
  "productTheme/BEA": "proizvodi-po-temama/pasulj",
  "productTheme/BIS": "proizvodi-po-temama/pasulj-u-sosu",
  "productTheme/BIO": "proizvodi-po-temama/bio",
  "productTheme/CAN": "proizvodi-po-temama/konzervirana-hrana",
  "productTheme/CER": "proizvodi-po-temama/zitarice",
  "productTheme/CLS": "proizvodi-po-temama/klasika",
  "productTheme/DLE": "proizvodi-po-temama/povrce",
  "productTheme/EDR": "proizvodi-po-temama/pojacivaci-ukusa",
  "productTheme/ENT": "proizvodi-po-temama/predjela",
  "productTheme/FRZ": "proizvodi-po-temama/zamrznuto",
  "productTheme/FSD": "proizvodi-po-temama/za-salate",
  "productTheme/FSH": "proizvodi-po-temama/naknade",
  "productTheme/ING": "proizvodi-po-temama/sastojci-za-moje-recepte",
  "productTheme/JAR": "proizvodi-po-temama/povrce-u-tegli",
  "productTheme/LBW": "proizvodi-po-temama/cinija-za-rucak",
  "productTheme/LDF": "proizvodi-po-temama/povrce-u-rerni",
  "productTheme/LEG": "proizvodi-po-temama/mahunarke",
  "productTheme/LGO": "proizvodi-po-temama/mahunarke",
  "productTheme/LGR": "proizvodi-po-temama/grilovano-povrce",
  "productTheme/LGS": "proizvodi-po-temama/povrce-za-supu",
  "productTheme/MAI": "proizvodi-po-temama/ali",
  "productTheme/MUS": "proizvodi-po-temama/pecurke",
  "productTheme/NEW": "proizvodi-po-temama/novi-proizvodi",
  "productTheme/PDH": "proizvodi-po-temama/suvo-povrce-kuhunja-jela",
  "productTheme/PDL": "proizvodi-po-temama/korpa-sa-povrcem",
  "productTheme/PHR": "proizvodi-po-temama/pasta-i-pasta",
  "productTheme/PLP": "proizvodi-po-temama/glavno-jelo",
  "productTheme/RAL": "proizvodi-po-temama/pirinac-povrce",
  "productTheme/RDM": "proizvodi-po-temama/kuhinjski-tanjiri",
  "productTheme/SAL": "proizvodi-po-temama/sve-za-moju-platu",
  "productTheme/SDB": "proizvodi-po-temama/cinija-za-salatu",
  "productTheme/SNK": "proizvodi-po-temama/grickanje",
  "productTheme/SUP": "proizvodi-po-temama/supa",
  "productTheme/TEX": "proizvodi-po-temama/teks-meks",
  "productTheme/VGP": "proizvodi-po-temama/povrce-proteini",
  "recipeTheme": "recepti-po-temama",
  "recipeTheme/01": "recepti-po-temama/praznicni-recepti",
  "recipeTheme/02": "recepti-po-temama/aperitiv",
  "recipeTheme/03": "recepti-po-temama/salate-i-grickalice",
  "recipeTheme/04": "recepti-po-temama/supe-i-gaspacosi",
  "recipeTheme/05": "recepti-po-temama/kis-pita-i-gratin",
  "recipeTheme/06": "recepti-po-temama/posebno-deca",
  "recipeTheme/07": "recepti-po-temama/dezerti",
  "recipeTheme/08": "recepti-po-temama/vegetarijanci",
  "recipeTheme/09": "recepti-po-temama/prilozi",
  "recipeTheme/10": "recepti-po-temama/dolazi-iz-daleka",
  "recipeTheme/11": "recepti-po-temama/dinstano",
  "recipeTheme/12": "recepti-po-temama/salate-i-rostilj",
  "recipeTheme/13": "recepti-po-temama/grickalice-i-meze",
  "recipeTheme/14": "recepti-po-temama/glavno-jelo",
  "recipeTheme/15": "recepti-po-temama/dezerti-i-peciva",
  "recipeTheme/16": "recepti-po-temama/predjela-i-supe",
  "recipeTheme/17": "recepti-po-temama/salate",
  "recipeTheme/18": "recepti-po-temama/cinije",
  "recipeTheme/19": "recepti-po-temama/supe",
  "recipeTheme/20": "recepti-po-temama/grickalice",
  "recipeTheme/21": "recepti-po-temama/sos",
  "recipeTheme/22": "recepti-po-temama/pojedinacna-jela",
  "recipeTheme/23": "recepti-po-temama/ostala-jela",
  "recipeTheme/24": "recepti-po-temama/jela-pecena-u-rerni",
  "recipeTheme/25": "recepti-po-temama/meksicka",
  "recipeTheme/26": "recepti-po-temama/oko-sveta",
  "recipeTheme/27": "recepti-po-temama/dan-bez-mesa",
  "recipeTheme/28": "recepti-po-temama/nizak-nivo-ugljenih-hidrata",
  "recipeTheme/33": "recepti-po-temama/osnova-sociva",
  "recipeTheme/34": "recepti-po-temama/baza-karfiola",
  "recipeTheme/35": "recepti-po-temama/baza-krompira",
  "recipeTheme/36": "recepti-po-temama/baza-sargarepe",
  "recipeTheme/37": "recepti-po-temama/baza-spanaca",
  "recipeTheme/38": "recepti-po-temama/osnova-paprike",
  "recipeTheme/39": "recepti-po-temama/baza-pecuraka",
  "recipeTheme/40": "recepti-po-temama/baza-ravnog-boranije",
  "recipeTheme/41": "recepti-po-temama/kukuruzna-baza",
  "recipeTheme/42": "recepti-po-temama/bazni-grasak",
  "recipeTheme/43": "recepti-po-temama/bazni-crveni-pasulj",
  "recipeTheme/44": "recepti-po-temama/baza-flageolet",
  "recipeTheme/45": "recepti-po-temama/baza-chickpea",
  "recipeTheme/46": "recepti-po-temama/baza-brokolija",
  "pred-particularite": "navike-u-ishrani",
  "pred-particularite/Sans%20conservateur": "navike-u-ishrani/bez-konzervansa",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "navike-u-ishrani",
  "pred-particularite/Sans%20colorant": "navike-u-ishrani/bez-boja",
  "pred-particularite/Sans%20sucre%20ajout%E9": "navike-u-ishrani/bez-dodatog-secera",
  "pred-particularite/Sans%20sel%20ajout%E9": "navike-u-ishrani/bez-dodate-soli",
  "pred-particularite/Sans%20additif": "navike-u-ishrani/bez-aditiva",
  "pred-particularite/": "navike-u-ishrani/prirodan-sadrzaj-soli",
  "pred-particularite/Sans%20lactose": "navike-u-ishrani/bez-laktoze",
  "pred-particularite/Sans%20gluten": "navike-u-ishrani/bez-glutena",
  "pred-particularite/V%E9g%E9tarien": "navike-u-ishrani/vegetarijansko",
  "pred-particularite/V%E9g%E9talien": "navike-u-ishrani/vegansko",
  "pred-particularite/Sans%20sulfite": "navike-u-ishrani/bez-sulfita",
  "pred-particularite/A%20la%20vapeur": "navike-u-ishrani/para",
  "pred-particularite/Sans%20condiment": "navike-u-ishrani/bez-zacina",
  "cultureType": "tip-kulture",
  "cultureType/Bio": "tip-kulture/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "tip-kulture/bez-ostatka-pesticida",
  "cultureType/Sans%20OGM": "tip-kulture/bez-gmo-a",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "navike-u-ishrani/vegansko",
  "pred-particularite/recipeVeggie": "navike-u-ishrani/vegetarijansko",
  "pred-particularite/recipeGlutenfree": "navike-u-ishrani/bez-glutena",
  "pred-particularite/recipeLactosefree": "navike-u-ishrani/bez-laktoze",
  "cultureOrigin": "poreklo-kulture",
  "cultureOrigin/31": "poreklo-kulture/azerbejdzan",
  "cultureOrigin/32": "poreklo-kulture/argentina",
  "cultureOrigin/36": "poreklo-kulture/australija",
  "cultureOrigin/40": "poreklo-kulture/austrija",
  "cultureOrigin/51": "poreklo-kulture/jermenija",
  "cultureOrigin/56": "poreklo-kulture/belgija",
  "cultureOrigin/68": "poreklo-kulture/bolivija",
  "cultureOrigin/70": "poreklo-kulture/bosna-i-herzegovina",
  "cultureOrigin/76": "poreklo-kulture/brazil",
  "cultureOrigin/97": "poreklo-kulture/evropska-unija",
  "cultureOrigin/100": "poreklo-kulture/bugarska",
  "cultureOrigin/104": "poreklo-kulture/burma",
  "cultureOrigin/120": "poreklo-kulture/kamerun",
  "cultureOrigin/124": "poreklo-kulture/kanada",
  "cultureOrigin/152": "poreklo-kulture/cile",
  "cultureOrigin/156": "poreklo-kulture/kina",
  "cultureOrigin/188": "poreklo-kulture/kostarika",
  "cultureOrigin/191": "poreklo-kulture/hrvatska",
  "cultureOrigin/196": "poreklo-kulture/kipar",
  "cultureOrigin/203": "poreklo-kulture/ceska-republika",
  "cultureOrigin/208": "poreklo-kulture/danska",
  "cultureOrigin/231": "poreklo-kulture/etiopija",
  "cultureOrigin/233": "poreklo-kulture/estonija",
  "cultureOrigin/246": "poreklo-kulture/finska",
  "cultureOrigin/250": "poreklo-kulture/francuska",
  "cultureOrigin/258": "poreklo-kulture/francuska-polinezija",
  "cultureOrigin/276": "poreklo-kulture/nemacka",
  "cultureOrigin/300": "poreklo-kulture/grcka",
  "cultureOrigin/320": "poreklo-kulture/gvatemala",
  "cultureOrigin/344": "poreklo-kulture/hongkong",
  "cultureOrigin/348": "poreklo-kulture/madarska",
  "cultureOrigin/352": "poreklo-kulture/island",
  "cultureOrigin/356": "poreklo-kulture/indija",
  "cultureOrigin/360": "poreklo-kulture/indonezija",
  "cultureOrigin/372": "poreklo-kulture/irska",
  "cultureOrigin/376": "poreklo-kulture/izrael",
  "cultureOrigin/380": "poreklo-kulture/italija",
  "cultureOrigin/398": "poreklo-kulture/kazakstan",
  "cultureOrigin/404": "poreklo-kulture/kenija",
  "cultureOrigin/414": "poreklo-kulture/kuvajt",
  "cultureOrigin/417": "poreklo-kulture/kirgistan",
  "cultureOrigin/422": "poreklo-kulture/liban",
  "cultureOrigin/428": "poreklo-kulture/letonija",
  "cultureOrigin/440": "poreklo-kulture/litvanija",
  "cultureOrigin/442": "poreklo-kulture/luksemburg",
  "cultureOrigin/450": "poreklo-kulture/madagaskar",
  "cultureOrigin/470": "poreklo-kulture/malta",
  "cultureOrigin/480": "poreklo-kulture/mauricijus",
  "cultureOrigin/484": "poreklo-kulture/meksiko",
  "cultureOrigin/498": "poreklo-kulture/moldavija",
  "cultureOrigin/499": "poreklo-kulture/crna-gora",
  "cultureOrigin/504": "poreklo-kulture/maroko",
  "cultureOrigin/528": "poreklo-kulture/holandija",
  "cultureOrigin/548": "poreklo-kulture/vanuatu",
  "cultureOrigin/578": "poreklo-kulture/norveska",
  "cultureOrigin/586": "poreklo-kulture/pakistan",
  "cultureOrigin/604": "poreklo-kulture/peru",
  "cultureOrigin/616": "poreklo-kulture/poljska",
  "cultureOrigin/620": "poreklo-kulture/portugal",
  "cultureOrigin/634": "poreklo-kulture/katar",
  "cultureOrigin/642": "poreklo-kulture/rumunija",
  "cultureOrigin/643": "poreklo-kulture/rusija",
  "cultureOrigin/703": "poreklo-kulture/slovacka",
  "cultureOrigin/704": "poreklo-kulture/vietnam",
  "cultureOrigin/705": "poreklo-kulture/slovenija",
  "cultureOrigin/724": "poreklo-kulture/spanija",
  "cultureOrigin/752": "poreklo-kulture/svedska",
  "cultureOrigin/756": "poreklo-kulture/svajcarska",
  "cultureOrigin/764": "poreklo-kulture/tajland",
  "cultureOrigin/784": "poreklo-kulture/ujedinjeni-arapski-emirati",
  "cultureOrigin/792": "poreklo-kulture/turska",
  "cultureOrigin/795": "poreklo-kulture/turkmenistan",
  "cultureOrigin/804": "poreklo-kulture/ukrajina",
  "cultureOrigin/818": "poreklo-kulture/egipat",
  "cultureOrigin/826": "poreklo-kulture/ujedinjeno-kraljevstvo",
  "cultureOrigin/834": "poreklo-kulture/tanzanija",
  "cultureOrigin/840": "poreklo-kulture/sjedinjene-americke-drzave",
  "cultureOrigin/999": "poreklo-kulture/izvoz",
  "cultureOrigin/NON_EU": "poreklo-kulture/ne-evropska-unija",
  "cultureOrigin/UE": "poreklo-kulture/evropska-unija",
  "cultureOrigin/XXX": "poreklo-kulture/prazno"
};
